import React from "react";
import { Snackbar, Alert, AlertTitle } from "@mui/material";

import { styled } from "@mui/material/styles";

const StyledSnackbar = styled((props) => <Snackbar {...props} />)(
    ({ theme }) => ({
        "& .MuiSnackbar-root": {
            top: theme.spacing(15),
        },
    })
);
export default function AlertDialog(props) {
    return (
        <>
            <StyledSnackbar
                open={props.data.isShow}
                autoHideDuration={10000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={props.onClose}
            >
                <Alert
                    variant="filled"
                    severity={props.data.severity}
                    onClose={props.onClose}>
                    <AlertTitle>{props.data.title}</AlertTitle>
                    {props.data.message}
                </Alert>
            </StyledSnackbar>
        </>
    );
}